<ng-container *ngIf="!fc">
    <ng-container *ngIf="message$ | async">{{message$ | async}}</ng-container>
</ng-container>